<div class="warp">
    <textarea autoresize [formControl]="answer"></textarea>
</div>